export const citys = [{
  "id": "35",
  "provinceCode:": "150000",
  "codeName": "阿拉善盟",
  "codeItemId": "152900",
  "initial": "A"
}, {
  "id": "38",
  "provinceCode:": "210000",
  "codeName": "鞍山市",
  "codeItemId": "210300",
  "initial": "A"
}, {
  "id": "105",
  "provinceCode:": "340000",
  "codeName": "安庆市",
  "codeItemId": "340800",
  "initial": "A"
}, {
  "id": "156",
  "provinceCode:": "410000",
  "codeName": "安阳市",
  "codeItemId": "410500",
  "initial": "A"
}, {
  "id": "256",
  "provinceCode:": "510000",
  "codeName": "阿坝藏族羌族自治州",
  "codeItemId": "513200",
  "initial": "A"
}, {
  "id": "262",
  "provinceCode:": "520000",
  "codeName": "安顺市",
  "codeItemId": "520400",
  "initial": "A"
}, {
  "id": "289",
  "provinceCode:": "540000",
  "codeName": "阿里地区",
  "codeItemId": "542500",
  "initial": "A"
}, {
  "id": "299",
  "provinceCode:": "610000",
  "codeName": "安康市",
  "codeItemId": "610900",
  "initial": "A"
}, {
  "id": "335",
  "provinceCode:": "650000",
  "codeName": "阿克苏地区",
  "codeItemId": "652900",
  "initial": "A"
}, {
  "id": "341",
  "provinceCode:": "650000",
  "codeName": "阿勒泰地区",
  "codeItemId": "654300",
  "initial": "A"
}, {
  "id": "1",
  "provinceCode:": "110000",
  "codeName": "北京市",
  "codeItemId": "110000",
  "initial": "B"
}, {
  "id": "7",
  "provinceCode:": "130000",
  "codeName": "保定市",
  "codeItemId": "130600",
  "initial": "B"
}, {
  "id": "25",
  "provinceCode:": "150000",
  "codeName": "包头市",
  "codeItemId": "150200",
  "initial": "B"
}, {
  "id": "31",
  "provinceCode:": "150000",
  "codeName": "巴彦淖尔市",
  "codeItemId": "150800",
  "initial": "B"
}, {
  "id": "40",
  "provinceCode:": "210000",
  "codeName": "本溪市",
  "codeItemId": "210500",
  "initial": "B"
}, {
  "id": "55",
  "provinceCode:": "220000",
  "codeName": "白山市",
  "codeItemId": "220600",
  "initial": "B"
}, {
  "id": "57",
  "provinceCode:": "220000",
  "codeName": "白城市",
  "codeItemId": "220800",
  "initial": "B"
}, {
  "id": "100",
  "provinceCode:": "340000",
  "codeName": "蚌埠市",
  "codeItemId": "340300",
  "initial": "B"
}, {
  "id": "150",
  "provinceCode:": "370000",
  "codeName": "滨州市",
  "codeItemId": "371600",
  "initial": "B"
}, {
  "id": "222",
  "provinceCode:": "450000",
  "codeName": "北海市",
  "codeItemId": "450500",
  "initial": "B"
}, {
  "id": "227",
  "provinceCode:": "450000",
  "codeName": "百色市",
  "codeItemId": "451000",
  "initial": "B"
}, {
  "id": "254",
  "provinceCode:": "510000",
  "codeName": "巴中市",
  "codeItemId": "511900",
  "initial": "B"
}, {
  "id": "265",
  "provinceCode:": "520000",
  "codeName": "毕节地区",
  "codeItemId": "522400",
  "initial": "B"
}, {
  "id": "271",
  "provinceCode:": "530000",
  "codeName": "保山市",
  "codeItemId": "530500",
  "initial": "B"
}, {
  "id": "293",
  "provinceCode:": "610000",
  "codeName": "宝鸡市",
  "codeItemId": "610300",
  "initial": "B"
}, {
  "id": "304",
  "provinceCode:": "620000",
  "codeName": "白银市",
  "codeItemId": "620400",
  "initial": "B"
}, {
  "id": "333",
  "provinceCode:": "650000",
  "codeName": "博尔塔拉蒙古自治州",
  "codeItemId": "652700",
  "initial": "B"
}, {
  "id": "334",
  "provinceCode:": "650000",
  "codeName": "巴音郭楞蒙古自治州",
  "codeItemId": "652800",
  "initial": "B"
}, {
  "id": "",
  "provinceCode:": "500000",
  "codeName": "重庆市",
  "codeItemId": "500000",
  "initial": "C"
}, {
  "id": "9",
  "provinceCode:": "130000",
  "codeName": "承德市",
  "codeItemId": "130800",
  "initial": "C"
}, {
  "id": "10",
  "provinceCode:": "130000",
  "codeName": "沧州市",
  "codeItemId": "130900",
  "initial": "C"
}, {
  "id": "16",
  "provinceCode:": "140000",
  "codeName": "长治市",
  "codeItemId": "140400",
  "initial": "C"
}, {
  "id": "27",
  "provinceCode:": "150000",
  "codeName": "赤峰市",
  "codeItemId": "150400",
  "initial": "C"
}, {
  "id": "48",
  "provinceCode:": "210000",
  "codeName": "朝阳市",
  "codeItemId": "211300",
  "initial": "C"
}, {
  "id": "50",
  "provinceCode:": "220000",
  "codeName": "长春市",
  "codeItemId": "220100",
  "initial": "C"
}, {
  "id": "77",
  "provinceCode:": "320000",
  "codeName": "常州市",
  "codeItemId": "320400",
  "initial": "C"
}, {
  "id": "107",
  "provinceCode:": "340000",
  "codeName": "滁州市",
  "codeItemId": "341100",
  "initial": "C"
}, {
  "id": "110",
  "provinceCode:": "340000",
  "codeName": "巢湖市",
  "codeItemId": "341400",
  "initial": "C"
}, {
  "id": "113",
  "provinceCode:": "340000",
  "codeName": "池州市",
  "codeItemId": "341700",
  "initial": "C"
}, {
  "id": "183",
  "provinceCode:": "430000",
  "codeName": "长沙市",
  "codeItemId": "430100",
  "initial": "C"
}, {
  "id": "189",
  "provinceCode:": "430000",
  "codeName": "常德市",
  "codeItemId": "430700",
  "initial": "C"
}, {
  "id": "192",
  "provinceCode:": "430000",
  "codeName": "郴州市",
  "codeItemId": "431000",
  "initial": "C"
}, {
  "id": "215",
  "provinceCode:": "440000",
  "codeName": "潮州市",
  "codeItemId": "445100",
  "initial": "C"
}, {
  "id": "231",
  "provinceCode:": "450000",
  "codeName": "崇左市",
  "codeItemId": "451400",
  "initial": "C"
}, {
  "id": "238",
  "provinceCode:": "510000",
  "codeName": "成都市",
  "codeItemId": "510100",
  "initial": "C"
}, {
  "id": "276",
  "provinceCode:": "530000",
  "codeName": "楚雄彝族自治州",
  "codeItemId": "532300",
  "initial": "C"
}, {
  "id": "285",
  "provinceCode:": "540000",
  "codeName": "昌都地区",
  "codeItemId": "542100",
  "initial": "C"
}, {
  "id": "332",
  "provinceCode:": "650000",
  "codeName": "昌吉回族自治州",
  "codeItemId": "652300",
  "initial": "C"
}, {
  "id": "14",
  "provinceCode:": "140000",
  "codeName": "大同市",
  "codeItemId": "140200",
  "initial": "D"
}, {
  "id": "37",
  "provinceCode:": "210000",
  "codeName": "大连市",
  "codeItemId": "210200",
  "initial": "D"
},{
  "id": "350",
  "provinceCode:": "460000",
  "codeName": "儋州市",
  "codeItemId": "460400",
  "initial": "D"
}, {
  "id": "41",
  "provinceCode:": "210000",
  "codeName": "丹东市",
  "codeItemId": "210600",
  "initial": "D"
}, {
  "id": "64",
  "provinceCode:": "230000",
  "codeName": "大庆市",
  "codeItemId": "230600",
  "initial": "D"
}, {
  "id": "71",
  "provinceCode:": "230000",
  "codeName": "大兴安岭地区",
  "codeItemId": "232700",
  "initial": "D"
}, {
  "id": "139",
  "provinceCode:": "370000",
  "codeName": "东营市",
  "codeItemId": "370500",
  "initial": "D"
}, {
  "id": "148",
  "provinceCode:": "370000",
  "codeName": "德州市",
  "codeItemId": "371400",
  "initial": "D"
}, {
  "id": "213",
  "provinceCode:": "440000",
  "codeName": "东莞市",
  "codeItemId": "441900",
  "initial": "D"
}, {
  "id": "242",
  "provinceCode:": "510000",
  "codeName": "德阳市",
  "codeItemId": "510600",
  "initial": "D"
}, {
  "id": "252",
  "provinceCode:": "510000",
  "codeName": "达州市",
  "codeItemId": "511700",
  "initial": "D"
}, {
  "id": "280",
  "provinceCode:": "530000",
  "codeName": "大理白族自治州",
  "codeItemId": "532900",
  "initial": "D"
}, {
  "id": "281",
  "provinceCode:": "530000",
  "codeName": "德宏傣族景颇族自治州",
  "codeItemId": "533100",
  "initial": "D"
}, {
  "id": "283",
  "provinceCode:": "530000",
  "codeName": "迪庆藏族自治州",
  "codeItemId": "533400",
  "initial": "D"
}, {
  "id": "311",
  "provinceCode:": "620000",
  "codeName": "定西市",
  "codeItemId": "621100",
  "initial": "D"
}, {
  "id": "29",
  "provinceCode:": "150000",
  "codeName": "鄂尔多斯市",
  "codeItemId": "150600",
  "initial": "E"
}, {
  "id": "174",
  "provinceCode:": "420000",
  "codeName": "鄂州市",
  "codeItemId": "420700",
  "initial": "E"
}, {
  "id": "181",
  "provinceCode:": "420000",
  "codeName": "恩施土家族苗族自治州",
  "codeItemId": "422800",
  "initial": "E"
}, {
  "id": "39",
  "provinceCode:": "210000",
  "codeName": "抚顺市",
  "codeItemId": "210400",
  "initial": "F"
}, {
  "id": "44",
  "provinceCode:": "210000",
  "codeName": "阜新市",
  "codeItemId": "210900",
  "initial": "F"
}, {
  "id": "108",
  "provinceCode:": "340000",
  "codeName": "阜阳市",
  "codeItemId": "341200",
  "initial": "F"
}, {
  "id": "115",
  "provinceCode:": "350000",
  "codeName": "福州市",
  "codeItemId": "350100",
  "initial": "F"
}, {
  "id": "133",
  "provinceCode:": "360000",
  "codeName": "抚州市",
  "codeItemId": "361000",
  "initial": "F"
}, {
  "id": "202",
  "provinceCode:": "440000",
  "codeName": "佛山市",
  "codeItemId": "440600",
  "initial": "F"
}, {
  "id": "223",
  "provinceCode:": "450000",
  "codeName": "防城港市",
  "codeItemId": "450600",
  "initial": "F"
}, {
  "id": "130",
  "provinceCode:": "360000",
  "codeName": "赣州市",
  "codeItemId": "360700",
  "initial": "G"
}, {
  "id": "197",
  "provinceCode:": "440000",
  "codeName": "广州市",
  "codeItemId": "440100",
  "initial": "G"
}, {
  "id": "220",
  "provinceCode:": "450000",
  "codeName": "桂林市",
  "codeItemId": "450300",
  "initial": "G"
}, {
  "id": "225",
  "provinceCode:": "450000",
  "codeName": "贵港市",
  "codeItemId": "450800",
  "initial": "G"
}, {
  "id": "244",
  "provinceCode:": "510000",
  "codeName": "广元市",
  "codeItemId": "510800",
  "initial": "G"
}, {
  "id": "251",
  "provinceCode:": "510000",
  "codeName": "广安市",
  "codeItemId": "511600",
  "initial": "G"
}, {
  "id": "257",
  "provinceCode:": "510000",
  "codeName": "甘孜藏族自治州",
  "codeItemId": "513300",
  "initial": "G"
}, {
  "id": "259",
  "provinceCode:": "520000",
  "codeName": "贵阳市",
  "codeItemId": "520100",
  "initial": "G"
}, {
  "id": "314",
  "provinceCode:": "620000",
  "codeName": "甘南藏族自治州",
  "codeItemId": "623000",
  "initial": "G"
}, {
  "id": "320",
  "provinceCode:": "630000",
  "codeName": "果洛藏族自治州",
  "codeItemId": "632600",
  "initial": "G"
}, {
  "id": "326",
  "provinceCode:": "640000",
  "codeName": "固原市",
  "codeItemId": "640400",
  "initial": "G"
}, {
  "id": "5",
  "provinceCode:": "130000",
  "codeName": "邯郸市",
  "codeItemId": "130400",
  "initial": "H"
}, {
  "id": "12",
  "provinceCode:": "130000",
  "codeName": "衡水市",
  "codeItemId": "131100",
  "initial": "H"
}, {
  "id": "24",
  "provinceCode:": "150000",
  "codeName": "呼和浩特市",
  "codeItemId": "150100",
  "initial": "H"
}, {
  "id": "30",
  "provinceCode:": "150000",
  "codeName": "呼伦贝尔市",
  "codeItemId": "150700",
  "initial": "H"
}, {
  "id": "49",
  "provinceCode:": "210000",
  "codeName": "葫芦岛市",
  "codeItemId": "211400",
  "initial": "H"
}, {
  "id": "59",
  "provinceCode:": "230000",
  "codeName": "哈尔滨市",
  "codeItemId": "230100",
  "initial": "H"
}, {
  "id": "62",
  "provinceCode:": "230000",
  "codeName": "鹤岗市",
  "codeItemId": "230400",
  "initial": "H"
}, {
  "id": "69",
  "provinceCode:": "230000",
  "codeName": "黑河市",
  "codeItemId": "231100",
  "initial": "H"
}, {
  "id": "81",
  "provinceCode:": "320000",
  "codeName": "淮安市",
  "codeItemId": "320800",
  "initial": "H"
}, {
  "id": "87",
  "provinceCode:": "330000",
  "codeName": "杭州市",
  "codeItemId": "330100",
  "initial": "H"
}, {
  "id": "91",
  "provinceCode:": "330000",
  "codeName": "湖州市",
  "codeItemId": "330500",
  "initial": "H"
}, {
  "id": "98",
  "provinceCode:": "340000",
  "codeName": "合肥市",
  "codeItemId": "340100",
  "initial": "H"
}, {
  "id": "101",
  "provinceCode:": "340000",
  "codeName": "淮南市",
  "codeItemId": "340400",
  "initial": "H"
}, {
  "id": "103",
  "provinceCode:": "340000",
  "codeName": "淮北市",
  "codeItemId": "340600",
  "initial": "H"
}, {
  "id": "106",
  "provinceCode:": "340000",
  "codeName": "黄山市",
  "codeItemId": "341000",
  "initial": "H"
}, {
  "id": "112",
  "provinceCode:": "340000",
  "codeName": "亳州市",
  "codeItemId": "341600",
  "initial": "H"
}, {
  "id": "151",
  "provinceCode:": "370000",
  "codeName": "荷泽市",
  "codeItemId": "371700",
  "initial": "H"
}, {
  "id": "157",
  "provinceCode:": "410000",
  "codeName": "鹤壁市",
  "codeItemId": "410600",
  "initial": "H"
}, {
  "id": "170",
  "provinceCode:": "420000",
  "codeName": "黄石市",
  "codeItemId": "420200",
  "initial": "H"
}, {
  "id": "178",
  "provinceCode:": "420000",
  "codeName": "黄冈市",
  "codeItemId": "421100",
  "initial": "H"
}, {
  "id": "186",
  "provinceCode:": "430000",
  "codeName": "衡阳市",
  "codeItemId": "430400",
  "initial": "H"
}, {
  "id": "194",
  "provinceCode:": "430000",
  "codeName": "怀化市",
  "codeItemId": "431200",
  "initial": "H"
}, {
  "id": "207",
  "provinceCode:": "440000",
  "codeName": "惠州市",
  "codeItemId": "441300",
  "initial": "H"
}, {
  "id": "210",
  "provinceCode:": "440000",
  "codeName": "河源市",
  "codeItemId": "441600",
  "initial": "H"
}, {
  "id": "228",
  "provinceCode:": "450000",
  "codeName": "贺州市",
  "codeItemId": "451100",
  "initial": "H"
}, {
  "id": "229",
  "provinceCode:": "450000",
  "codeName": "河池市",
  "codeItemId": "451200",
  "initial": "H"
}, {
  "id": "232",
  "provinceCode:": "460000",
  "codeName": "海口市",
  "codeItemId": "460100",
  "initial": "H"
}, {
  "id": "277",
  "provinceCode:": "530000",
  "codeName": "红河哈尼族彝族自治州",
  "codeItemId": "532500",
  "initial": "H"
}, {
  "id": "297",
  "provinceCode:": "610000",
  "codeName": "汉中市",
  "codeItemId": "610700",
  "initial": "H"
}, {
  "id": "316",
  "provinceCode:": "630000",
  "codeName": "海东地区",
  "codeItemId": "632100",
  "initial": "H"
}, {
  "id": "317",
  "provinceCode:": "630000",
  "codeName": "海北藏族自治州",
  "codeItemId": "632200",
  "initial": "H"
}, {
  "id": "318",
  "provinceCode:": "630000",
  "codeName": "黄南藏族自治州",
  "codeItemId": "632300",
  "initial": "H"
}, {
  "id": "319",
  "provinceCode:": "630000",
  "codeName": "海南藏族自治州",
  "codeItemId": "632500",
  "initial": "H"
}, {
  "id": "322",
  "provinceCode:": "630000",
  "codeName": "海西蒙古族藏族自治州",
  "codeItemId": "632800",
  "initial": "H"
}, {
  "id": "331",
  "provinceCode:": "650000",
  "codeName": "哈密地区",
  "codeItemId": "652200",
  "initial": "H"
}, {
  "id": "338",
  "provinceCode:": "650000",
  "codeName": "和田地区",
  "codeItemId": "653200",
  "initial": "H"
}, {
  "id": "17",
  "provinceCode:": "140000",
  "codeName": "晋城市",
  "codeItemId": "140500",
  "initial": "J"
}, {
  "id": "19",
  "provinceCode:": "140000",
  "codeName": "晋中市",
  "codeItemId": "140700",
  "initial": "J"
}, {
  "id": "42",
  "provinceCode:": "210000",
  "codeName": "锦州市",
  "codeItemId": "210700",
  "initial": "J"
}, {
  "id": "51",
  "provinceCode:": "220000",
  "codeName": "吉林市",
  "codeItemId": "220200",
  "initial": "J"
}, {
  "id": "61",
  "provinceCode:": "230000",
  "codeName": "鸡西市",
  "codeItemId": "230300",
  "initial": "J"
}, {
  "id": "66",
  "provinceCode:": "230000",
  "codeName": "佳木斯市",
  "codeItemId": "230800",
  "initial": "J"
}, {
  "id": "90",
  "provinceCode:": "330000",
  "codeName": "嘉兴市",
  "codeItemId": "330400",
  "initial": "J"
}, {
  "id": "93",
  "provinceCode:": "330000",
  "codeName": "金华市",
  "codeItemId": "330700",
  "initial": "J"
}, {
  "id": "125",
  "provinceCode:": "360000",
  "codeName": "景德镇市",
  "codeItemId": "360200",
  "initial": "J"
}, {
  "id": "127",
  "provinceCode:": "360000",
  "codeName": "九江市",
  "codeItemId": "360400",
  "initial": "J"
}, {
  "id": "131",
  "provinceCode:": "360000",
  "codeName": "吉安市",
  "codeItemId": "360800",
  "initial": "J"
}, {
  "id": "135",
  "provinceCode:": "370000",
  "codeName": "济南市",
  "codeItemId": "370100",
  "initial": "J"
}, {
  "id": "142",
  "provinceCode:": "370000",
  "codeName": "济宁市",
  "codeItemId": "370800",
  "initial": "J"
}, {
  "id": "159",
  "provinceCode:": "410000",
  "codeName": "焦作市",
  "codeItemId": "410800",
  "initial": "J"
}, {
  "id": "175",
  "provinceCode:": "420000",
  "codeName": "荆门市",
  "codeItemId": "420800",
  "initial": "J"
}, {
  "id": "177",
  "provinceCode:": "420000",
  "codeName": "荆州市",
  "codeItemId": "421000",
  "initial": "J"
}, {
  "id": "203",
  "provinceCode:": "440000",
  "codeName": "江门市",
  "codeItemId": "440700",
  "initial": "J"
}, {
  "id": "216",
  "provinceCode:": "440000",
  "codeName": "揭阳市",
  "codeItemId": "445200",
  "initial": "J"
}, {
  "id": "302",
  "provinceCode:": "620000",
  "codeName": "嘉峪关市",
  "codeItemId": "620200",
  "initial": "J"
}, {
  "id": "303",
  "provinceCode:": "620000",
  "codeName": "金昌市",
  "codeItemId": "620300",
  "initial": "J"
}, {
  "id": "309",
  "provinceCode:": "620000",
  "codeName": "酒泉市",
  "codeItemId": "620900",
  "initial": "J"
}, {
  "id": "153",
  "provinceCode:": "410000",
  "codeName": "开封市",
  "codeItemId": "410200",
  "initial": "K"
}, {
  "id": "268",
  "provinceCode:": "530000",
  "codeName": "昆明市",
  "codeItemId": "530100",
  "initial": "K"
}, {
  "id": "329",
  "provinceCode:": "650000",
  "codeName": "克拉玛依市",
  "codeItemId": "650200",
  "initial": "K"
}, {
  "id": "336",
  "provinceCode:": "650000",
  "codeName": "克孜勒苏柯尔克孜自治州",
  "codeItemId": "653000",
  "initial": "K"
}, {
  "id": "337",
  "provinceCode:": "650000",
  "codeName": "喀什地区",
  "codeItemId": "653100",
  "initial": "K"
}, {
  "id": "11",
  "provinceCode:": "130000",
  "codeName": "廊坊市",
  "codeItemId": "131000",
  "initial": "L"
}, {
  "id": "22",
  "provinceCode:": "140000",
  "codeName": "临汾市",
  "codeItemId": "141000",
  "initial": "L"
}, {
  "id": "23",
  "provinceCode:": "140000",
  "codeName": "吕梁市",
  "codeItemId": "141100",
  "initial": "L"
}, {
  "id": "45",
  "provinceCode:": "210000",
  "codeName": "辽阳市",
  "codeItemId": "211000",
  "initial": "L"
}, {
  "id": "53",
  "provinceCode:": "220000",
  "codeName": "辽源市",
  "codeItemId": "220400",
  "initial": "L"
}, {
  "id": "80",
  "provinceCode:": "320000",
  "codeName": "连云港市",
  "codeItemId": "320700",
  "initial": "L"
}, {
  "id": "97",
  "provinceCode:": "330000",
  "codeName": "丽水市",
  "codeItemId": "331100",
  "initial": "L"
}, {
  "id": "111",
  "provinceCode:": "340000",
  "codeName": "六安市",
  "codeItemId": "341500",
  "initial": "L"
}, {
  "id": "122",
  "provinceCode:": "350000",
  "codeName": "龙岩市",
  "codeItemId": "350800",
  "initial": "L"
}, {
  "id": "146",
  "provinceCode:": "370000",
  "codeName": "莱芜市",
  "codeItemId": "371200",
  "initial": "L"
}, {
  "id": "147",
  "provinceCode:": "370000",
  "codeName": "临沂市",
  "codeItemId": "371300",
  "initial": "L"
}, {
  "id": "149",
  "provinceCode:": "370000",
  "codeName": "聊城市",
  "codeItemId": "371500",
  "initial": "L"
}, {
  "id": "154",
  "provinceCode:": "410000",
  "codeName": "洛阳市",
  "codeItemId": "410300",
  "initial": "L"
}, {
  "id": "162",
  "provinceCode:": "410000",
  "codeName": "漯河市",
  "codeItemId": "411100",
  "initial": "L"
}, {
  "id": "195",
  "provinceCode:": "430000",
  "codeName": "娄底市",
  "codeItemId": "431300",
  "initial": "L"
}, {
  "id": "219",
  "provinceCode:": "450000",
  "codeName": "柳州市",
  "codeItemId": "450200",
  "initial": "L"
}, {
  "id": "230",
  "provinceCode:": "450000",
  "codeName": "来宾市",
  "codeItemId": "451300",
  "initial": "L"
}, {
  "id": "241",
  "provinceCode:": "510000",
  "codeName": "泸州市",
  "codeItemId": "510500",
  "initial": "L"
}, {
  "id": "247",
  "provinceCode:": "510000",
  "codeName": "乐山市",
  "codeItemId": "511100",
  "initial": "L"
}, {
  "id": "258",
  "provinceCode:": "510000",
  "codeName": "凉山彝族自治州",
  "codeItemId": "513400",
  "initial": "L"
}, {
  "id": "260",
  "provinceCode:": "520000",
  "codeName": "六盘水市",
  "codeItemId": "520200",
  "initial": "L"
}, {
  "id": "273",
  "provinceCode:": "530000",
  "codeName": "丽江市",
  "codeItemId": "530700",
  "initial": "L"
}, {
  "id": "275",
  "provinceCode:": "530000",
  "codeName": "临沧市",
  "codeItemId": "530900",
  "initial": "L"
}, {
  "id": "284",
  "provinceCode:": "540000",
  "codeName": "拉萨市",
  "codeItemId": "540100",
  "initial": "L"
}, {
  "id": "290",
  "provinceCode:": "540000",
  "codeName": "林芝地区",
  "codeItemId": "542600",
  "initial": "L"
}, {
  "id": "301",
  "provinceCode:": "620000",
  "codeName": "兰州市",
  "codeItemId": "620100",
  "initial": "L"
}, {
  "id": "312",
  "provinceCode:": "620000",
  "codeName": "陇南市",
  "codeItemId": "621200",
  "initial": "L"
}, {
  "id": "313",
  "provinceCode:": "620000",
  "codeName": "临夏回族自治州",
  "codeItemId": "622900",
  "initial": "L"
},{
  "id": "351",
  "provinceCode:": "460000",
  "codeName": "陵水市",
  "codeItemId": "469028",
  "initial": "L"
},{
  "id": "68",
  "provinceCode:": "230000",
  "codeName": "牡丹江市",
  "codeItemId": "231000",
  "initial": "M"
}, {
  "id": "102",
  "provinceCode:": "340000",
  "codeName": "马鞍山市",
  "codeItemId": "340500",
  "initial": "M"
}, {
  "id": "205",
  "provinceCode:": "440000",
  "codeName": "茂名市",
  "codeItemId": "440900",
  "initial": "M"
}, {
  "id": "208",
  "provinceCode:": "440000",
  "codeName": "梅州市",
  "codeItemId": "441400",
  "initial": "M"
}, {
  "id": "243",
  "provinceCode:": "510000",
  "codeName": "绵阳市",
  "codeItemId": "510700",
  "initial": "M"
}, {
  "id": "249",
  "provinceCode:": "510000",
  "codeName": "眉山市",
  "codeItemId": "511400",
  "initial": "M"
}, {
  "id": "74",
  "provinceCode:": "320000",
  "codeName": "南京市",
  "codeItemId": "320100",
  "initial": "N"
}, {
  "id": "79",
  "provinceCode:": "320000",
  "codeName": "南通市",
  "codeItemId": "320600",
  "initial": "N"
}, {
  "id": "88",
  "provinceCode:": "330000",
  "codeName": "宁波市",
  "codeItemId": "330200",
  "initial": "N"
}, {
  "id": "121",
  "provinceCode:": "350000",
  "codeName": "南平市",
  "codeItemId": "350700",
  "initial": "N"
}, {
  "id": "123",
  "provinceCode:": "350000",
  "codeName": "宁德市",
  "codeItemId": "350900",
  "initial": "N"
}, {
  "id": "124",
  "provinceCode:": "360000",
  "codeName": "南昌市",
  "codeItemId": "360100",
  "initial": "N"
}, {
  "id": "164",
  "provinceCode:": "410000",
  "codeName": "南阳市",
  "codeItemId": "411300",
  "initial": "N"
}, {
  "id": "218",
  "provinceCode:": "450000",
  "codeName": "南宁市",
  "codeItemId": "450100",
  "initial": "N"
}, {
  "id": "246",
  "provinceCode:": "510000",
  "codeName": "内江市",
  "codeItemId": "511000",
  "initial": "N"
}, {
  "id": "248",
  "provinceCode:": "510000",
  "codeName": "南充市",
  "codeItemId": "511300",
  "initial": "N"
}, {
  "id": "282",
  "provinceCode:": "530000",
  "codeName": "怒江傈僳族自治州",
  "codeItemId": "533300",
  "initial": "N"
}, {
  "id": "288",
  "provinceCode:": "540000",
  "codeName": "那曲地区",
  "codeItemId": "542400",
  "initial": "N"
}, {
  "id": "46",
  "provinceCode:": "210000",
  "codeName": "盘锦市",
  "codeItemId": "211100",
  "initial": "P"
}, {
  "id": "117",
  "provinceCode:": "350000",
  "codeName": "莆田市",
  "codeItemId": "350300",
  "initial": "P"
}, {
  "id": "126",
  "provinceCode:": "360000",
  "codeName": "萍乡市",
  "codeItemId": "360300",
  "initial": "P"
}, {
  "id": "155",
  "provinceCode:": "410000",
  "codeName": "平顶山市",
  "codeItemId": "410400",
  "initial": "P"
}, {
  "id": "160",
  "provinceCode:": "410000",
  "codeName": "濮阳市",
  "codeItemId": "410900",
  "initial": "P"
}, {
  "id": "240",
  "provinceCode:": "510000",
  "codeName": "攀枝花市",
  "codeItemId": "510400",
  "initial": "P"
}, {
  "id": "308",
  "provinceCode:": "620000",
  "codeName": "平凉市",
  "codeItemId": "620800",
  "initial": "P"
}, {
  "id": "4",
  "provinceCode:": "130000",
  "codeName": "秦皇岛市",
  "codeItemId": "130300",
  "initial": "Q"
}, {
  "id": "60",
  "provinceCode:": "230000",
  "codeName": "齐齐哈尔市",
  "codeItemId": "230200",
  "initial": "Q"
}, {
  "id": "67",
  "provinceCode:": "230000",
  "codeName": "七台河市",
  "codeItemId": "230900",
  "initial": "Q"
}, {
  "id": "94",
  "provinceCode:": "330000",
  "codeName": "衢州市",
  "codeItemId": "330800",
  "initial": "Q"
}, {
  "id": "119",
  "provinceCode:": "350000",
  "codeName": "泉州市",
  "codeItemId": "350500",
  "initial": "Q"
}, {
  "id": "136",
  "provinceCode:": "370000",
  "codeName": "青岛市",
  "codeItemId": "370200",
  "initial": "Q"
}, {
  "id": "212",
  "provinceCode:": "440000",
  "codeName": "清远市",
  "codeItemId": "441800",
  "initial": "Q"
}, {
  "id": "224",
  "provinceCode:": "450000",
  "codeName": "钦州市",
  "codeItemId": "450700",
  "initial": "Q"
}, {
  "id": "264",
  "provinceCode:": "520000",
  "codeName": "黔西南布依族苗族自治州",
  "codeItemId": "522300",
  "initial": "Q"
}, {
  "id": "266",
  "provinceCode:": "520000",
  "codeName": "黔东南苗族侗族自治州",
  "codeItemId": "522600",
  "initial": "Q"
}, {
  "id": "267",
  "provinceCode:": "520000",
  "codeName": "黔南布依族苗族自治州",
  "codeItemId": "522700",
  "initial": "Q"
}, {
  "id": "269",
  "provinceCode:": "530000",
  "codeName": "曲靖市",
  "codeItemId": "530300",
  "initial": "Q"
}, {
  "id": "310",
  "provinceCode:": "620000",
  "codeName": "庆阳市",
  "codeItemId": "621000",
  "initial": "Q"
}, {
  "id": "145",
  "provinceCode:": "370000",
  "codeName": "日照市",
  "codeItemId": "371100",
  "initial": "R"
}, {
  "id": "287",
  "provinceCode:": "540000",
  "codeName": "日喀则地区",
  "codeItemId": "542300",
  "initial": "R"
}, {
  "id": "2",
  "provinceCode:": "130000",
  "codeName": "石家庄市",
  "codeItemId": "130100",
  "initial": "S"
}, {
  "id": "",
  "provinceCode:": "310000",
  "codeName": "上海市",
  "codeItemId": "310000",
  "initial": "S"
}, {
  "id": "18",
  "provinceCode:": "140000",
  "codeName": "朔州市",
  "codeItemId": "140600",
  "initial": "S"
}, {
  "id": "36",
  "provinceCode:": "210000",
  "codeName": "沈阳市",
  "codeItemId": "210100",
  "initial": "S"
}, {
  "id": "52",
  "provinceCode:": "220000",
  "codeName": "四平市",
  "codeItemId": "220300",
  "initial": "S"
}, {
  "id": "56",
  "provinceCode:": "220000",
  "codeName": "松原市",
  "codeItemId": "220700",
  "initial": "S"
}, {
  "id": "63",
  "provinceCode:": "230000",
  "codeName": "双鸭山市",
  "codeItemId": "230500",
  "initial": "S"
}, {
  "id": "70",
  "provinceCode:": "230000",
  "codeName": "绥化市",
  "codeItemId": "231200",
  "initial": "S"
}, {
  "id": "78",
  "provinceCode:": "320000",
  "codeName": "苏州市",
  "codeItemId": "320500",
  "initial": "S"
}, {
  "id": "86",
  "provinceCode:": "320000",
  "codeName": "宿迁市",
  "codeItemId": "321300",
  "initial": "S"
}, {
  "id": "92",
  "provinceCode:": "330000",
  "codeName": "绍兴市",
  "codeItemId": "330600",
  "initial": "S"
}, {
  "id": "109",
  "provinceCode:": "340000",
  "codeName": "宿州市",
  "codeItemId": "341300",
  "initial": "S"
}, {
  "id": "118",
  "provinceCode:": "350000",
  "codeName": "三明市",
  "codeItemId": "350400",
  "initial": "S"
}, {
  "id": "134",
  "provinceCode:": "360000",
  "codeName": "上饶市",
  "codeItemId": "361100",
  "initial": "S"
}, {
  "id": "163",
  "provinceCode:": "410000",
  "codeName": "三门峡市",
  "codeItemId": "411200",
  "initial": "S"
}, {
  "id": "165",
  "provinceCode:": "410000",
  "codeName": "商丘市",
  "codeItemId": "411400",
  "initial": "S"
}, {
  "id": "171",
  "provinceCode:": "420000",
  "codeName": "十堰市",
  "codeItemId": "420300",
  "initial": "S"
}, {
  "id": "180",
  "provinceCode:": "420000",
  "codeName": "随州市",
  "codeItemId": "421300",
  "initial": "S"
}, {
  "id": "187",
  "provinceCode:": "430000",
  "codeName": "邵阳市",
  "codeItemId": "430500",
  "initial": "S"
}, {
  "id": "198",
  "provinceCode:": "440000",
  "codeName": "韶关市",
  "codeItemId": "440200",
  "initial": "S"
}, {
  "id": "199",
  "provinceCode:": "440000",
  "codeName": "深圳市",
  "codeItemId": "440300",
  "initial": "S"
}, {
  "id": "201",
  "provinceCode:": "440000",
  "codeName": "汕头市",
  "codeItemId": "440500",
  "initial": "S"
}, {
  "id": "209",
  "provinceCode:": "440000",
  "codeName": "汕尾市",
  "codeItemId": "441500",
  "initial": "S"
}, {
  "id": "233",
  "provinceCode:": "460000",
  "codeName": "三亚市",
  "codeItemId": "460200",
  "initial": "S"
}, {
  "id": "245",
  "provinceCode:": "510000",
  "codeName": "遂宁市",
  "codeItemId": "510900",
  "initial": "S"
}, {
  "id": "274",
  "provinceCode:": "530000",
  "codeName": "思茅市",
  "codeItemId": "530800",
  "initial": "S"
}, {
  "id": "286",
  "provinceCode:": "540000",
  "codeName": "山南地区",
  "codeItemId": "542200",
  "initial": "S"
}, {
  "id": "300",
  "provinceCode:": "610000",
  "codeName": "商洛市",
  "codeItemId": "611000",
  "initial": "S"
}, {
  "id": "324",
  "provinceCode:": "640000",
  "codeName": "石嘴山市",
  "codeItemId": "640200",
  "initial": "S"
}, {
  "id": "3",
  "provinceCode:": "130000",
  "codeName": "唐山市",
  "codeItemId": "130200",
  "initial": "T"
}, {
  "id": "13",
  "provinceCode:": "140000",
  "codeName": "太原市",
  "codeItemId": "140100",
  "initial": "T"
}, {
  "id": "28",
  "provinceCode:": "150000",
  "codeName": "通辽市",
  "codeItemId": "150500",
  "initial": "T"
}, {
  "id": "47",
  "provinceCode:": "210000",
  "codeName": "铁岭市",
  "codeItemId": "211200",
  "initial": "T"
}, {
  "id": "54",
  "provinceCode:": "220000",
  "codeName": "通化市",
  "codeItemId": "220500",
  "initial": "T"
}, {
  "id": "85",
  "provinceCode:": "320000",
  "codeName": "泰州市",
  "codeItemId": "321200",
  "initial": "T"
}, {
  "id": "96",
  "provinceCode:": "330000",
  "codeName": "台州市",
  "codeItemId": "331000",
  "initial": "T"
}, {
  "id": "104",
  "provinceCode:": "340000",
  "codeName": "铜陵市",
  "codeItemId": "340700",
  "initial": "T"
}, {
  "id": "143",
  "provinceCode:": "370000",
  "codeName": "泰安市",
  "codeItemId": "370900",
  "initial": "T"
}, {
  "id": "263",
  "provinceCode:": "520000",
  "codeName": "铜仁地区",
  "codeItemId": "522200",
  "initial": "T"
}, {
  "id": "292",
  "provinceCode:": "610000",
  "codeName": "铜川市",
  "codeItemId": "610200",
  "initial": "T"
}, {
  "id": "305",
  "provinceCode:": "620000",
  "codeName": "天水市",
  "codeItemId": "620500",
  "initial": "T"
}, {
  "id": "330",
  "provinceCode:": "650000",
  "codeName": "吐鲁番地区",
  "codeItemId": "652100",
  "initial": "T"
}, {
  "id": "340",
  "provinceCode:": "650000",
  "codeName": "塔城地区",
  "codeItemId": "654200",
  "initial": "T"
}, {
  "id": "343",
  "provinceCode:": "120000",
  "codeName": "天津市",
  "codeItemId": "120000",
  "initial": "T"
}, {
  "id": "26",
  "provinceCode:": "150000",
  "codeName": "乌海市",
  "codeItemId": "150300",
  "initial": "W"
}, {
  "id": "32",
  "provinceCode:": "150000",
  "codeName": "乌兰察布市",
  "codeItemId": "150900",
  "initial": "W"
}, {
  "id": "75",
  "provinceCode:": "320000",
  "codeName": "无锡市",
  "codeItemId": "320200",
  "initial": "W"
}, {
  "id": "89",
  "provinceCode:": "330000",
  "codeName": "温州市",
  "codeItemId": "330300",
  "initial": "W"
}, {
  "id": "99",
  "provinceCode:": "340000",
  "codeName": "芜湖市",
  "codeItemId": "340200",
  "initial": "W"
}, {
  "id": "141",
  "provinceCode:": "370000",
  "codeName": "潍坊市",
  "codeItemId": "370700",
  "initial": "W"
}, {
  "id": "144",
  "provinceCode:": "370000",
  "codeName": "威海市",
  "codeItemId": "371000",
  "initial": "W"
}, {
  "id": "169",
  "provinceCode:": "420000",
  "codeName": "武汉市",
  "codeItemId": "420100",
  "initial": "W"
}, {
  "id": "221",
  "provinceCode:": "450000",
  "codeName": "梧州市",
  "codeItemId": "450400",
  "initial": "W"
}, {
  "id": "278",
  "provinceCode:": "530000",
  "codeName": "文山壮族苗族自治州",
  "codeItemId": "532600",
  "initial": "W"
}, {
  "id": "295",
  "provinceCode:": "610000",
  "codeName": "渭南市",
  "codeItemId": "610500",
  "initial": "W"
}, {
  "id": "306",
  "provinceCode:": "620000",
  "codeName": "武威市",
  "codeItemId": "620600",
  "initial": "W"
}, {
  "id": "325",
  "provinceCode:": "640000",
  "codeName": "吴忠市",
  "codeItemId": "640300",
  "initial": "W"
}, {
  "id": "328",
  "provinceCode:": "650000",
  "codeName": "乌鲁木齐市",
  "codeItemId": "650100",
  "initial": "W"
}, {
  "id": "6",
  "provinceCode:": "130000",
  "codeName": "邢台市",
  "codeItemId": "130500",
  "initial": "X"
}, {
  "id": "21",
  "provinceCode:": "140000",
  "codeName": "忻州市",
  "codeItemId": "140900",
  "initial": "X"
}, {
  "id": "33",
  "provinceCode:": "150000",
  "codeName": "兴安盟",
  "codeItemId": "152200",
  "initial": "X"
}, {
  "id": "34",
  "provinceCode:": "150000",
  "codeName": "锡林郭勒盟",
  "codeItemId": "152500",
  "initial": "X"
}, {
  "id": "76",
  "provinceCode:": "320000",
  "codeName": "徐州市",
  "codeItemId": "320300",
  "initial": "X"
}, {
  "id": "114",
  "provinceCode:": "340000",
  "codeName": "宣城市",
  "codeItemId": "341800",
  "initial": "X"
}, {
  "id": "116",
  "provinceCode:": "350000",
  "codeName": "厦门市",
  "codeItemId": "350200",
  "initial": "X"
}, {
  "id": "128",
  "provinceCode:": "360000",
  "codeName": "新余市",
  "codeItemId": "360500",
  "initial": "X"
}, {
  "id": "158",
  "provinceCode:": "410000",
  "codeName": "新乡市",
  "codeItemId": "410700",
  "initial": "X"
}, {
  "id": "161",
  "provinceCode:": "410000",
  "codeName": "许昌市",
  "codeItemId": "411000",
  "initial": "X"
}, {
  "id": "166",
  "provinceCode:": "410000",
  "codeName": "信阳市",
  "codeItemId": "411500",
  "initial": "X"
}, {
  "id": "173",
  "provinceCode:": "420000",
  "codeName": "襄樊市",
  "codeItemId": "420600",
  "initial": "X"
}, {
  "id": "176",
  "provinceCode:": "420000",
  "codeName": "孝感市",
  "codeItemId": "420900",
  "initial": "X"
}, {
  "id": "179",
  "provinceCode:": "420000",
  "codeName": "咸宁市",
  "codeItemId": "421200",
  "initial": "X"
}, {
  "id": "185",
  "provinceCode:": "430000",
  "codeName": "湘潭市",
  "codeItemId": "430300",
  "initial": "X"
}, {
  "id": "196",
  "provinceCode:": "430000",
  "codeName": "湘西土家族苗族自治州",
  "codeItemId": "433100",
  "initial": "X"
}, {
  "id": "279",
  "provinceCode:": "530000",
  "codeName": "西双版纳傣族自治州",
  "codeItemId": "532800",
  "initial": "X"
}, {
  "id": "291",
  "provinceCode:": "610000",
  "codeName": "西安市",
  "codeItemId": "610100",
  "initial": "X"
}, {
  "id": "294",
  "provinceCode:": "610000",
  "codeName": "咸阳市",
  "codeItemId": "610400",
  "initial": "X"
}, {
  "id": "315",
  "provinceCode:": "630000",
  "codeName": "西宁市",
  "codeItemId": "630100",
  "initial": "X"
}, {
  "id": "15",
  "provinceCode:": "140000",
  "codeName": "阳泉市",
  "codeItemId": "140300",
  "initial": "Y"
}, {
  "id": "20",
  "provinceCode:": "140000",
  "codeName": "运城市",
  "codeItemId": "140800",
  "initial": "Y"
}, {
  "id": "43",
  "provinceCode:": "210000",
  "codeName": "营口市",
  "codeItemId": "210800",
  "initial": "Y"
}, {
  "id": "58",
  "provinceCode:": "220000",
  "codeName": "延边朝鲜族自治州",
  "codeItemId": "222400",
  "initial": "Y"
}, {
  "id": "65",
  "provinceCode:": "230000",
  "codeName": "伊春市",
  "codeItemId": "230700",
  "initial": "Y"
}, {
  "id": "82",
  "provinceCode:": "320000",
  "codeName": "盐城市",
  "codeItemId": "320900",
  "initial": "Y"
}, {
  "id": "83",
  "provinceCode:": "320000",
  "codeName": "扬州市",
  "codeItemId": "321000",
  "initial": "Y"
}, {
  "id": "129",
  "provinceCode:": "360000",
  "codeName": "鹰潭市",
  "codeItemId": "360600",
  "initial": "Y"
}, {
  "id": "132",
  "provinceCode:": "360000",
  "codeName": "宜春市",
  "codeItemId": "360900",
  "initial": "Y"
}, {
  "id": "140",
  "provinceCode:": "370000",
  "codeName": "烟台市",
  "codeItemId": "370600",
  "initial": "Y"
}, {
  "id": "172",
  "provinceCode:": "420000",
  "codeName": "宜昌市",
  "codeItemId": "420500",
  "initial": "Y"
}, {
  "id": "188",
  "provinceCode:": "430000",
  "codeName": "岳阳市",
  "codeItemId": "430600",
  "initial": "Y"
}, {
  "id": "191",
  "provinceCode:": "430000",
  "codeName": "益阳市",
  "codeItemId": "430900",
  "initial": "Y"
}, {
  "id": "193",
  "provinceCode:": "430000",
  "codeName": "永州市",
  "codeItemId": "431100",
  "initial": "Y"
}, {
  "id": "211",
  "provinceCode:": "440000",
  "codeName": "阳江市",
  "codeItemId": "441700",
  "initial": "Y"
}, {
  "id": "217",
  "provinceCode:": "440000",
  "codeName": "云浮市",
  "codeItemId": "445300",
  "initial": "Y"
}, {
  "id": "226",
  "provinceCode:": "450000",
  "codeName": "玉林市",
  "codeItemId": "450900",
  "initial": "Y"
}, {
  "id": "250",
  "provinceCode:": "510000",
  "codeName": "宜宾市",
  "codeItemId": "511500",
  "initial": "Y"
}, {
  "id": "253",
  "provinceCode:": "510000",
  "codeName": "雅安市",
  "codeItemId": "511800",
  "initial": "Y"
}, {
  "id": "270",
  "provinceCode:": "530000",
  "codeName": "玉溪市",
  "codeItemId": "530400",
  "initial": "Y"
}, {
  "id": "296",
  "provinceCode:": "610000",
  "codeName": "延安市",
  "codeItemId": "610600",
  "initial": "Y"
}, {
  "id": "298",
  "provinceCode:": "610000",
  "codeName": "榆林市",
  "codeItemId": "610800",
  "initial": "Y"
}, {
  "id": "321",
  "provinceCode:": "630000",
  "codeName": "玉树藏族自治州",
  "codeItemId": "632700",
  "initial": "Y"
}, {
  "id": "323",
  "provinceCode:": "640000",
  "codeName": "银川市",
  "codeItemId": "640100",
  "initial": "Y"
}, {
  "id": "339",
  "provinceCode:": "650000",
  "codeName": "伊犁哈萨克自治州",
  "codeItemId": "654000",
  "initial": "Y"
}, {
  "id": "8",
  "provinceCode:": "130000",
  "codeName": "张家口市",
  "codeItemId": "130700",
  "initial": "Z"
}, {
  "id": "84",
  "provinceCode:": "320000",
  "codeName": "镇江市",
  "codeItemId": "321100",
  "initial": "Z"
}, {
  "id": "95",
  "provinceCode:": "330000",
  "codeName": "舟山市",
  "codeItemId": "330900",
  "initial": "Z"
}, {
  "id": "120",
  "provinceCode:": "350000",
  "codeName": "漳州市",
  "codeItemId": "350600",
  "initial": "Z"
}, {
  "id": "137",
  "provinceCode:": "370000",
  "codeName": "淄博市",
  "codeItemId": "370300",
  "initial": "Z"
}, {
  "id": "138",
  "provinceCode:": "370000",
  "codeName": "枣庄市",
  "codeItemId": "370400",
  "initial": "Z"
}, {
  "id": "152",
  "provinceCode:": "410000",
  "codeName": "郑州市",
  "codeItemId": "410100",
  "initial": "Z"
}, {
  "id": "167",
  "provinceCode:": "410000",
  "codeName": "周口市",
  "codeItemId": "411600",
  "initial": "Z"
}, {
  "id": "168",
  "provinceCode:": "410000",
  "codeName": "驻马店市",
  "codeItemId": "411700",
  "initial": "Z"
}, {
  "id": "184",
  "provinceCode:": "430000",
  "codeName": "株洲市",
  "codeItemId": "430200",
  "initial": "Z"
}, {
  "id": "190",
  "provinceCode:": "430000",
  "codeName": "张家界市",
  "codeItemId": "430800",
  "initial": "Z"
}, {
  "id": "200",
  "provinceCode:": "440000",
  "codeName": "珠海市",
  "codeItemId": "440400",
  "initial": "Z"
}, {
  "id": "204",
  "provinceCode:": "440000",
  "codeName": "湛江市",
  "codeItemId": "440800",
  "initial": "Z"
}, {
  "id": "206",
  "provinceCode:": "440000",
  "codeName": "肇庆市",
  "codeItemId": "441200",
  "initial": "Z"
}, {
  "id": "214",
  "provinceCode:": "440000",
  "codeName": "中山市",
  "codeItemId": "442000",
  "initial": "Z"
}, {
  "id": "239",
  "provinceCode:": "510000",
  "codeName": "自贡市",
  "codeItemId": "510300",
  "initial": "Z"
}, {
  "id": "255",
  "provinceCode:": "510000",
  "codeName": "资阳市",
  "codeItemId": "512000",
  "initial": "Z"
}, {
  "id": "261",
  "provinceCode:": "520000",
  "codeName": "遵义市",
  "codeItemId": "520300",
  "initial": "Z"
}, {
  "id": "272",
  "provinceCode:": "530000",
  "codeName": "昭通市",
  "codeItemId": "530600",
  "initial": "Z"
}, {
  "id": "307",
  "provinceCode:": "620000",
  "codeName": "张掖市",
  "codeItemId": "620700",
  "initial": "Z"
}, {
  "id": "327",
  "provinceCode:": "640000",
  "codeName": "中卫市",
  "codeItemId": "640500",
  "initial": "Z"
}]
